import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-onyx border-t border-bone/8 pt-16 pb-8">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid grid-cols-12 gap-10">
        {/* Brand + description */}
        <div className="col-span-12 md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="font-display italic-display text-3xl text-brass leading-none">Д</span>
            <div>
              <div className="font-display text-xl text-bone tracking-tight">Джавала Мрамор</div>
              <div className="text-[0.65rem] tracking-[0.32em] uppercase text-taupe">Premium stone care · UA</div>
            </div>
          </div>
          <p className="mt-5 text-bone/60 text-sm leading-relaxed max-w-sm">
            Преміальне полірування, реставрація та захист мармуру по всій Україні. 20 років досвіду, гарантія 2 роки.
          </p>
          <div className="mt-6 space-y-2 text-sm">
            <a href="tel:+380957955234" className="block text-bone/80 hover:text-brass transition-colors">+38 (095) 795-52-34</a>
            <a href="mailto:djavala.mramor@gmail.com" className="block text-bone/80 hover:text-brass transition-colors">djavala.mramor@gmail.com</a>
            <div className="text-taupe text-xs">Київ, Україна · ФОП «Джавала Мрамор»</div>
          </div>
        </div>

        {/* Sections */}
        <div className="col-span-6 md:col-span-2">
          <div className="text-[0.65rem] tracking-[0.32em] uppercase text-brass mb-4">Розділи</div>
          <ul className="space-y-3 text-sm text-bone/70">
            <li><a href="/#services" className="hover:text-brass transition-colors">Послуги</a></li>
            <li><a href="/#gallery" className="hover:text-brass transition-colors">Галерея</a></li>
            <li><a href="/#about" className="hover:text-brass transition-colors">Про нас</a></li>
            <li><a href="/#faq" className="hover:text-brass transition-colors">FAQ</a></li>
            <li><a href="/#contact" className="hover:text-brass transition-colors">Контакти</a></li>
          </ul>
        </div>

        {/* Cabinet */}
        <div className="col-span-6 md:col-span-2">
          <div className="text-[0.65rem] tracking-[0.32em] uppercase text-brass mb-4">Кабінет</div>
          <ul className="space-y-3 text-sm text-bone/70">
            <li><Link to="/dashboard" className="hover:text-brass transition-colors">Мої заявки</Link></li>
            <li><a href="viber://chat?number=%2B380957955234" className="hover:text-brass transition-colors">Viber</a></li>
            <li><a href="https://wa.me/380957955234" target="_blank" rel="noreferrer" className="hover:text-brass transition-colors">WhatsApp</a></li>
            <li><a href="https://t.me/dzhavala_marmor" target="_blank" rel="noreferrer" className="hover:text-brass transition-colors">Telegram</a></li>
          </ul>
        </div>

        {/* Legal */}
        <div className="col-span-12 md:col-span-3">
          <div className="text-[0.65rem] tracking-[0.32em] uppercase text-brass mb-4">Правова інформація</div>
          <ul className="space-y-3 text-sm text-bone/70">
            <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-brass transition-colors">Політика конфіденційності</Link></li>
            <li><Link to="/terms" data-testid="footer-terms" className="hover:text-brass transition-colors">Умови користування</Link></li>
            <li><Link to="/cookies" data-testid="footer-cookies" className="hover:text-brass transition-colors">Політика cookies</Link></li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 mt-12 pt-8 border-t border-bone/10 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-xs text-taupe">© {new Date().getFullYear()} Джавала Мрамор. Усі права захищено.</div>
        <div className="text-[0.65rem] tracking-[0.32em] uppercase text-taupe">Made with · Cormorant · Manrope</div>
      </div>
    </footer>
  );
}
